import React, { Fragment } from 'react'
import { TextAddComments } from './TextAddComments';
import { CommentItem } from './CommentItem';

export default function ContainerCommentList(
    {
        fields,
        add,
        remove,
        nameList,
        reasons,
        comments,
        buttonsCheked,
        checkAll,
        isBlockNewComment,
        rules,
        handleAddComment,
        handleSaveComment,
        handleDeleteComment,
        handleSelectChange,
        disableIputs
    }
) {

    if (fields.length === 0) {
        return (
            <Fragment>
                {!disableIputs && (
                    <TextAddComments
                        onClick={() => handleAddComment(add, 0)}
                        disable={rules?.isAddComment}
                    >
                        Agregar comentario +
                    </TextAddComments>
                )}
                {nameList === "cotizacion" && (<div className='h-[320px]' />)}
            </Fragment>
        )
    }

    return (
        <Fragment>
            {fields.map(({ key, name }, index) => (
                <div
                    key={`${key}-comments-container`}
                    className='flex flex-col gap-4'
                >
                    <CommentItem
                        key={`${key}-comments-container`}
                        name={name}
                        reasons={reasons}
                        comments={comments}
                        isPutComment={buttonsCheked[name]}
                        checkedValue={checkAll[name]}
                        disabled={!disableIputs ? buttonsCheked[name] : true}
                        actionSaveEdit={() => handleSaveComment(name)}
                        actionDelete={() => handleDeleteComment(remove, name, fields)}
                        onChangue={(e) => handleSelectChange(name, e.target.checked)}
                    />
                </div>
            ))}
            <div className='mt-2'>
                {!disableIputs && (
                    <TextAddComments
                        onClick={() => handleAddComment(add, fields.length)}
                        disable={isBlockNewComment}
                    >
                        Agregar comentario +
                    </TextAddComments>
                )}
            </div>
        </Fragment>
    );
}
